import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { useRef } from "react";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { InputBase } from "./auth-service-tools309.js";
import { PillsInputProvider } from "./auth-service-tools384.js";
import { PillsInputField } from "./auth-service-tools389.js";
const defaultProps = {};
const PillsInput = factory((_props, ref) => {
  const props = useProps("PillsInput", defaultProps, _props);
  const {
    children,
    onMouseDown,
    onClick,
    size,
    disabled,
    __staticSelector,
    error,
    variant,
    ...others
  } = props;
  const fieldRef = useRef();
  return /* @__PURE__ */jsxRuntimeExports.jsx(PillsInputProvider, {
    value: {
      fieldRef,
      size,
      disabled,
      hasError: !!error,
      variant
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(InputBase, {
      size,
      error,
      variant,
      component: "div",
      ref,
      onMouseDown: event => {
        var _a;

        event.preventDefault();
        onMouseDown == null ? void 0 : onMouseDown(event);
        (_a = fieldRef.current) == null ? void 0 : _a.focus();
      },
      onClick: event => {
        var _a;

        event.preventDefault();
        onClick == null ? void 0 : onClick(event);
        (_a = fieldRef.current) == null ? void 0 : _a.focus();
      },
      ...others,
      multiline: true,
      disabled,
      __staticSelector: __staticSelector || "PillsInput",
      withAria: false,
      children
    })
  });
});
PillsInput.displayName = "@mantine/core/PillsInput";
PillsInput.Field = PillsInputField;
export { PillsInput };